module.exports = __webpack_public_path__ + "img/rjc.fa109c66.jpg";